// extracted by mini-css-extract-plugin
export var active = "_dk-7";
export var blink = "_dk-8";
export var dropDownSelector = "_dk-4";
export var dropDownWrapper = "_dk-3";
export var fakeCursor = "_dk-6";
export var fontSizeButton = "_dk-9";
export var formQuillEditor = "_dk-0";
export var pressed = "_dk-a";
export var qlBlank = "_dk-1";
export var textFormattingToolbar = "_dk-2";
export var textToolbarOption = "_dk-5";